import {
	ADD_TICKET_HISTORY_FAIL,
	ADD_TICKET_HISTORY_START, ADD_TICKET_HISTORY_SUCCESS, CLEAN_SEARCHED_TICKETS,
	GENERATE_TICKET_FAIL,
	GENERATE_TICKET_START,
	GENERATE_TICKET_SUCCESS, GET_ALL_INFO_FAIL, GET_ALL_INFO_START, GET_ALL_INFO_SUCCESS,
	GET_TICKET_HISTORY_FAIL,
	GET_TICKET_HISTORY_START,
	GET_TICKET_HISTORY_SUCCESS,
	SEARCH_TICKET_FAIL,
	SEARCH_TICKET_START,
	SEARCH_TICKET_SUCCESS
} from "./actions/ActionTypes";

export const initTicketState = () => {
	return {
		loadingAddTicket: true,
		errorAddTicket: "",
		loadingSearchTicket: true,
		errorSearchTicket: "",
		searchedTickets: [],
		loadingGetHistory: true,
		errorGetHistory: "",
		ticketHistory: [],
		loadingAddHistory: true,
		errorAddHistory: "",
		loadingGetInfo: true,
		errorGetInfo: "",
		infoTickets: {},
	}
}

export const TICKET_INITIAL_STATE = {}

export const TicketReducer = (state = TICKET_INITIAL_STATE, action) => {
	//console.log(action);
	switch (action.type) {
		case GENERATE_TICKET_START:
			return {
				...state,
				loadingAddTicket: true,
				errorAddTicket: "",
			}
		case GENERATE_TICKET_SUCCESS:
			return {
				...state,
				loadingAddTicket: false,
				errorAddTicket: "",
				searchedTickets: [],
			}
		case GENERATE_TICKET_FAIL:
			return {
				...state,
				loadingAddTicket: false,
				errorAddTicket: action.error,
			}
		case SEARCH_TICKET_START:
			return {
				...state,
				loadingSearchTicket: true,
				errorSearchTicket: "",
				searchedTickets: [],
			}
		case SEARCH_TICKET_SUCCESS:
			return {
				...state,
				loadingSearchTicket: false,
				errorSearchTicket: "",
				searchedTickets: action.payload,
			}
		case SEARCH_TICKET_FAIL:
			return {
				...state,
				loadingSearchTicket: false,
				errorSearchTicket: action.error,
				searchedTickets: [],
			}
		case CLEAN_SEARCHED_TICKETS:
			return {
				...state,
				loadingSearchTicket: false,
				errorSearchTicket: "",
				searchedTickets: [],
			}
		case GET_TICKET_HISTORY_START:
			return {
				...state,
				loadingGetHistory: true,
				errorGetHistory: "",
				ticketHistory: [],
			}
		case GET_TICKET_HISTORY_SUCCESS:
			return {
				...state,
				loadingGetHistory: false,
				errorGetHistory: "",
				ticketHistory: action.payload,
			}
		case GET_TICKET_HISTORY_FAIL:
			return {
				...state,
				loadingGetHistory: false,
				errorGetHistory: action.error,
				ticketHistory: [],
			}
		case ADD_TICKET_HISTORY_START:
			return {
				...state,
				loadingAddHistory: true,
				errorAddHistory: "",
			}
		case ADD_TICKET_HISTORY_SUCCESS:
			return {
				...state,
				loadingAddHistory: false,
				errorAddHistory: "",
			}
		case ADD_TICKET_HISTORY_FAIL:
			return {
				...state,
				loadingAddHistory: false,
				errorAddHistory: action.error,
			}
		case GET_ALL_INFO_START:
			return {
				...state,
				loadingGetInfo: true,
				errorGetInfo: "",
				infoTickets: {},
			}
		case GET_ALL_INFO_SUCCESS:
			return {
				...state,
				loadingGetInfo: false,
				errorGetInfo: "",
				infoTickets: action.payload,
			}
		case GET_ALL_INFO_FAIL:
			return {
				...state,
				loadingGetInfo: false,
				errorGetInfo: action.error,
				infoTickets: {},
			}
		
		default:
			return state;
	}
}
